module.exports = __webpack_public_path__ + "static/media/t_pl.f40cdbb2.pdf";